import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';

const SECRET_KEY = '3y^#7*H8w@Kz!pL9mD&4t$FqZ8^QbR#2sT*jV5zN#1x'; // Use a strong secret key

const encryptValue = (value) => {
    const valueToEncrypt = typeof value === 'string' ? value : String(value);
    return CryptoJS.AES.encrypt(valueToEncrypt, SECRET_KEY).toString();
};

const decryptValue = (encryptedValue) => {
    const bytes = CryptoJS.AES.decrypt(encryptedValue, SECRET_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
};


export function setCookieWithExpiration(name, value, minutes){
    const encryptedValue = encryptValue(value);
    Cookies.set(name, encryptedValue, {expires: minutes, secure: true, sameSite: 'Strict'});
    //Cookies.set(name, encryptedValue, {expires: minutes});
}

export function isCookieValid(name){
    return Cookies.get(name) !==undefined;
}

export function deleteCookie(name){
    Cookies.remove(name);
}
export function getCookie(name){
    const encryptedValue = Cookies.get(name);
    if (encryptedValue) {
        return decryptValue(encryptedValue);
    }
    return null;
}

export function updateCookieExpiration(name, options){
    const currentValue = Cookies.get(name);
    if(currentValue){
        Cookies.set(name, currentValue, options);
    }
}

export function updateCookieValue(name, newValue, options){
    const currentValue = Cookies.get(name);
    if(currentValue){
        const encryptedValue = encryptValue(newValue);
        Cookies.set(name, encryptedValue, options);
    }
}